import type {
  CheckQuotaContent,
  CheckQuotaReq,
  CheckTicketRequest,
  CheckTicketResponse,
  ClassSubTypeData,
  LivestreamData,
  LivestreamRequest,
  PlayOrDownloadReq,
  PlayOrDownloadRes,
  PreCheckDownloadParams,
  PreCheckDownloadResponse,
  UseLiveStreamTicketRequest,
  UseLiveStreamTicketResponse,
  VideoData,
  VideoRequest
} from '@/models/interface/videoLibrary';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class VideoLibraryService extends ApiFactory {
  constructor() {
    super('Library');
  }

  fetchClassSubType(): Promise<ApiDataResponse<ClassSubTypeData[]>> {
    return super.get('ClassSubTypes');
  }

  fetchVideoData(params: VideoRequest): Promise<ApiDataResponse<VideoData>> {
    return super.post('Videos', params);
  }

  fetchLiveStreamingData(params: LivestreamRequest): Promise<ApiDataResponse<LivestreamData>> {
    return super.get('LiveStream', params);
  }

  fetchCheckQuota(params: CheckQuotaReq): Promise<ApiDataResponse<CheckQuotaContent>> {
    return super.get('CheckDownloadQuota', params);
  }

  fetchPlayOrDownload(classId: PlayOrDownloadReq): Promise<ApiDataResponse<PlayOrDownloadRes>> {
    return super.post('PlayVideo?classId=' + classId, '');
  }

  fetchPlayOrDownloadHistory(): Promise<ApiDataResponse<string[]>> {
    return super.get('History');
  }

  checkLiveStreamTicket(params: CheckTicketRequest): Promise<ApiDataResponse<CheckTicketResponse>> {
    return super.get('CheckTicket', params);
  }

  useLiveStreamTicket(
    params: UseLiveStreamTicketRequest
  ): Promise<ApiDataResponse<UseLiveStreamTicketResponse>> {
    return super.post('UseLiveStreamTicket', undefined, { params });
  }

  /**
   * 直播下載/播放前檢查
   * @param params
   * @returns
   */
  preCheckDownload(
    params: PreCheckDownloadParams
  ): Promise<ApiDataResponse<PreCheckDownloadResponse>> {
    return super.get('PreCheckDownload', params);
  }
}
